import { render, staticRenderFns } from "./Material.vue?vue&type=template&id=1a9b163d&scoped=true"
import script from "./Material.vue?vue&type=script&lang=ts"
export * from "./Material.vue?vue&type=script&lang=ts"
import style0 from "./Material.vue?vue&type=style&index=0&id=1a9b163d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9b163d",
  null
  
)

export default component.exports